import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import {
    MEDIA_QUERY_BREAKPOINT_S,
    MEDIA_QUERY_BREAKPOINT_MD,
    MEDIA_QUERY_BREAKPOINT_L,
    MEDIA_QUERY_BREAKPOINT_XL,
    MEDIA_QUERY_BREAKPOINT_XXL,
    MEDIA_QUERY_HEIGHT_BREAKPOINT_M,
} from './breakpoint-observer.constants';

@Injectable({
    providedIn: 'root',
})
export class BreakpointObserverService {
    private breakpointObserver = inject(BreakpointObserver);

    isSmallView$: Observable<boolean> = this.breakpointObserver
        .observe(MEDIA_QUERY_BREAKPOINT_S)
        .pipe(
            map((result: BreakpointState) => {
                return !result.matches;
            }),
        );

    isMobileView$: Observable<boolean> = this.breakpointObserver
        .observe(MEDIA_QUERY_BREAKPOINT_MD)
        .pipe(
            map((result: BreakpointState) => {
                return !result.matches;
            }),
        );

    isTabletLargeView$: Observable<boolean> = this.breakpointObserver
        .observe(MEDIA_QUERY_BREAKPOINT_L)
        .pipe(
            map((result: BreakpointState) => {
                return !result.matches;
            }),
        );

    isTabletXLargeView$: Observable<boolean> = this.breakpointObserver
        .observe(MEDIA_QUERY_BREAKPOINT_XL)
        .pipe(
            map((result: BreakpointState) => {
                return !result.matches;
            }),
        );

    isTabletView$: Observable<boolean> = this.breakpointObserver
        .observe(MEDIA_QUERY_BREAKPOINT_XXL)
        .pipe(
            map((result: BreakpointState) => {
                return !result.matches;
            }),
        );

    isMediumHeightView$: Observable<boolean> = this.breakpointObserver
        .observe(MEDIA_QUERY_HEIGHT_BREAKPOINT_M)
        .pipe(
            map((result: BreakpointState) => {
                return !result.matches;
            }),
        );
}
